<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-form ref="form" @submit.prevent="atualizar()">
      <v-card class="elevation-0" :disabled="loading">
        <v-toolbar :color="this.getAppBarColor" dark>Editar Usuario</v-toolbar>
        <v-card-text>
          <v-text-field
            v-model="usuario.nome"
            label="Nome"
            type="text"
            prepend-icon="mdi-account-circle"
            class="mt-2"
            :rules="[rules.required]"
          />
          <v-text-field
            v-model="usuario.apelido"
            label="Apelido"
            type="text"
            prepend-icon="mdi-account-circle-outline"
            class="mt-2"
            :rules="[rules.required]"
          />
          <v-text-field
            v-model="usuario.telefone"
            label="Contato"
            type="text"
            hint="Contato do Whatsapp"
            persistent-hint
            prepend-icon="mdi-whatsapp"
            v-mask="'(##) #####-####'"
            class="mt-2"
            :rules="[rules.required]"
          />
          <v-autocomplete
            v-model="usuario.papel"
            label="Papel"
            :items="papeis"
            item-text="nome"
            item-value="id"
            prepend-icon="mdi-shield-key"
            :rules="[rules.required]"
          />
          <v-autocomplete
            v-model="usuario.prefix"
            label="Prefixo"
            :items="prefixos"
            prepend-icon="mdi-database-lock"
            :rules="[rules.required]"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="ma-3 pl-5 pr-5"
            color="blue darken-1"
            type="submit"
            outlined
            small
            dark
            rounded
            depressed
            :loading="loading"
          >
            <v-icon left>mdi-content-save</v-icon>Salvar
          </v-btn>

          <v-btn
            class="ma-3 pl-5 pr-5"
            color="red darken-2"
            type="button"
            outlined
            small
            dark
            rounded
            depressed
            @click="hide()"
          >
            <v-icon left>mdi-close</v-icon>Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Usuarios from '@/services/usuarios'
import Papeis from '@/services/papeis'
import Colaboradores from '@/services/colaboradores'
import rules from '@/utils/rules'

export default {
  name: 'DialogEditarUsuario',

  data() {
    return {
      dialog: false,
      loading: false,
      rules: rules,

      usuario: new Object(),
      papeis: [],
      prefixos: ['dev', 'prod']
    }
  },

  methods: {
    async show(usuario) {
      this.loading = true
      this.dialog = true
      this.usuario = usuario

      try
      {
        if(!this.usuario.papel)
        {
          let colaborador = await new Colaboradores().getById(usuario.cpf)
          if(colaborador) this.usuario.papel = colaborador.papel || ''
        }
      }
      finally
      {
        this.loading = false
      }
    },

    hide() {
      this.dialog = false
      this.usuario = new Object()
    },

    async atualizar()
    {
      if(!this.$refs.form.validate()) return

      try
      {
        this.loading = true
        await new Usuarios().update(this.usuario)
        this.$emit('update')
      }
      catch(error)
      {
        console.error(error)
        this.$swal.error(error)
      }
      finally
      {
        this.loading = false
      }
    },

    async start() {
      try
      {
        this.papeis = await new Papeis().list()
      }
      catch(error)
      {
        console.error(error)
        this.$swal.error(error)
      }
    },
  },

  mounted() {
    this.start()
  }
}
</script>
